module.exports = __webpack_public_path__ + "static/sport/btn-main.32bc068.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/btn-main.gif
// module id = S34Z
// module chunks = 0